import React from 'react'
import { makeStyles } from '@mui/styles'

import SVGIcon from '../../svg-icon/svg-icon'
import BackArrowIcon from 'assets/images/icons/arrow_left.svg'
import { Link } from 'react-router'

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 20,
    fontSize: 24,
  },
}))

function ListHeaderBackButton(props) {
  const { url } = props
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      <Link to={url}>
        <SVGIcon svg={BackArrowIcon} height='15px' width='15px' />
      </Link>
    </div>
  )
}

export default ListHeaderBackButton
